import { useState, useEffect, useCallback } from 'react';
import { authenticatedFetch } from '../utils/fetch';

/**
 * Hook to fetch and manage the connection status between this
 * Shopify store and the ApparelHub platform.
 */
export default function useConnectionStatus() {
  const [isConnected, setIsConnected] = useState(false);
  const [accountEmail, setAccountEmail] = useState(null);
  const [storeName, setStoreName] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authenticatedFetch('/api/connection-status');
      if (response.ok) {
        const data = await response.json();
        setIsConnected(!!data.connected);
        setAccountEmail(data.user_email || null);
        setStoreName(data.store_name || null);
      } else {
        setIsConnected(false);
      }
    } catch (error) {
      console.error('Failed to fetch connection status:', error);
      setIsConnected(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { isConnected, accountEmail, storeName, loading, refresh };
}
